import React from 'react';
import {Trans} from 'react-i18next';
import {INotification} from '../../../incase-domain/notification';

interface ExpiredPasswordTextProps {
    notification: INotification;
}

function ExpiredPresentationPasswordText({notification}: ExpiredPasswordTextProps): JSX.Element | null {
    let bodyText = '';

    const today = new Date();
    const createdDate = new Date(notification.created);

    today.setHours(0, 0, 0, 0);
    createdDate.setHours(0, 0, 0, 0);

    if (createdDate.getDate() === today.getDate() - 1) {
        bodyText = 'today';
    } else if (createdDate.getDate() === today.getDate()) {
        bodyText = 'tomorrow';
    } else {
        bodyText = 'expired';
    }

    return ((): JSX.Element | null => {
        return <Trans i18nKey={`notifications.presentationPassword.${bodyText}` as never} components={{bold: <strong />}} />;
    })();
}

export default ExpiredPresentationPasswordText;
